<template>
  <div class="fullheight">
    <el-form v-loading.fullscreen.lock="fullscreenLoading"  data-vv-scope="pwdStrategyForm">
      <eco-form-item label="初始化密码" label-width="120px">
        <eco-input
          v-model="form.initPwd"
          autocomplete="off"
          :validate="{ required: true }"
          placeholder="请输入初始化密码"
        ></eco-input>
      </eco-form-item>
      <!--      <eco-form-item label="密码规则" label-width="120px">-->
      <!--        <eco-select-->
      <!--          v-model="form.pwdRule"-->
      <!--          :options="options"-->
      <!--          :validate="{ required: true }"-->
      <!--        >-->
      <!--        </eco-select>-->
      <!--      </eco-form-item>-->
<!--      <eco-form-item label="密码最小长度" label-width="120px">-->
<!--        <eco-input-->
<!--          v-model="form.pwdLength"-->
<!--          type="number"-->
<!--          :min="0"-->
<!--          :max="30"-->
<!--          :validate="{ required: true }"-->
<!--          placeholder="请输入密码最小长度"-->
<!--        ></eco-input>-->
<!--      </eco-form-item>-->
    </el-form>
   
      <el-button class="confirm" type="primary" @click="confirm()" 
          style="margin: 20px 0 0 120px"
      
        >保存</el-button
      >
  </div>
</template>

<script>
import uc from "@/api/uc.js";
import utils from "@/eco-ui-util.js";

export default {
  name: "sys-pwd-strategy",
  components: {},
  props: {
    tenantId: String
  },
  computed: {},
  data() {
    return {
      fullscreenLoading: false,
      form: {
        pwdLength: 0,
        initPwd: "",
        pwdRule: "1"
      },
      options: [
        { key: 1, value: "无限制" },
        { key: 2, value: "必须包含数字、字母" },
        { key: 3, value: "必须包含数字、字母、特殊字符" },
        { key: 4, value: "必须包含数字、大小字母、特殊字符" }
      ]
    };
  },
  mounted() {
    let params = {
      tenantId: this.tenantId
    };
    uc.getDefaultPwdStrategy(params).then(data => {
      if (data) {
        let form = data;
        //
        this.form = form;
      }
    });
  },
  methods: {
    confirm() {
      utils
        .validateForm(this, "pwdStrategyForm")
        .then(r => {
          console.log(r)
          if (r) {
            this.fullscreenLoading = true;
            let param = {};
            Object.assign(param, this.form);
            uc.saveDefaultPwdStrategy(param).then(
              data => {
                this.fullscreenLoading = false;
                if (data.state) {
                  this.$message.success(data.message);
                } else {
                  this.$message.error(data.message || "保存失败");
                }
              },
              error => {
                this.fullscreenLoading = false;
                this.$message.error(error || "保存失败");
              }
            );
          }
        })
        .catch(reason => {
          this.fullscreenLoading = false;
          this.$message.error("表单校验不通过，请检查表单");
        });
    }
  },
  created() {}
};
</script>

<style lang="scss" scoped>
.confirm {
  margin-left: 120px;
}
</style>
